/* jshint node:true */
'use strict';

module.exports = function(appUid){

    var Fluxible = require('fluxible');

    var app = new Fluxible({
        component: require('./configs/routes.jsx')
    });

    app.uid = appUid;

    app.registerStore(require('./stores/ScoreStore'));
    app.registerStore(require('./stores/StandingsStore'));
    app.registerStore(require('./stores/LeagueStore'));
    app.registerStore(require('./stores/ScoreboardStore'));
    app.registerStore(require('./stores/ScheduleStore'));
    app.registerStore(require('./stores/HomeStore'));

    app.plug(require('./plugins/Services'));

    return app;

};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/index.js
 **/